import React from 'react';
import Text from '../../ui/Text';
import {
    Big9OmWrapper,
    Big9OmContent,
    Big9OmImageWrapper,
    BetLineItemWrapper,
    Big9OmLeagueIcon,
    ButtonsWrapper,
    BetDefault,
    BetWider,
    WildcardActive,
    Big9OmSetBetTopLine,
    Big9OmSetBetWrapper,
    Big9OmSetBetSettings,
    Big9OmSetBetSettingsItem,
    Big9OmSetBetAmountItem,
    Big9OmSetBetAmountWrapper,
    ArrowTop,
} from './styled';
import engIcon from './../../images/icons/big9/eng.svg';
import ArrowRightImg from './../../images/arrowRight.svg';
import { detectMobile } from '../../utils/UiHelper';
import Video from '../Video';

const Big9Om = () => {
    return (
        <Big9OmWrapper>
            <Big9OmContent>
                <Text
                    size="x25"
                    padding="0"
                    weight="900"
                    align="left"
                    color="#333333"
                >
                    Sådan spiller du Big 9:
                </Text>
                <Text
                    margin={detectMobile() ? '15px 0 0' : '25px 0 0'}
                    padding="0"
                    align="left"
                    color="#333333"
                    lh={'22'}
                >
                    Vælg 1, X eller 2 af alle ni kampe. Det er muligt at lave
                    både halv- og helgarderinger, men du betaler for hver
                    kombination.
                </Text>
                <Text
                    margin={detectMobile() ? '15px 0 0' : '25px 0 0'}
                    padding="0"
                    align="left"
                    color="#333333"
                    lh={'22'}
                >
                    Vælg, om du tror, der kommer over eller under 2,5 mål i hver
                    kamp. Det er muligt at vælge begge udfald, men du betaler
                    for hver kombination.
                </Text>
                <Text
                    margin={detectMobile() ? '15px 0 0' : '25px 0 0'}
                    padding="0"
                    align="left"
                    color="#333333"
                    lh={'22'}
                >
                    Du kan bruge et wildcard på en vilkårlig kamp, som er en
                    gratis helgardering.
                </Text>

                <Video src={'https://www.youtube.com/embed/X_7GZ9AIjfk'} />

                <Text
                    margin={'40px 0 0'}
                    size="x25"
                    padding="0"
                    weight="900"
                    align="left"
                    color="#333333"
                >
                    Wildcard
                </Text>
                <Text
                    margin={detectMobile() ? '15px 0 0' : '25px 0 0'}
                    size="x1"
                    padding="0"
                    align="left"
                    color="#333333"
                    lh={'22'}
                >
                    Du har altid et gratis wildcard, som du skal bruge på én af
                    kuponens ni kampe. Det vil sige, at du vælger alle udfald i
                    kampen (1X2 samt over og under 2,5 mål) og er garanteret at
                    ramme kampen rigtig. Du aktiverer dit wildcard ved at trykke
                    på Wildcard ud for den kamp, hvor du vil anvende det.
                </Text>
                <Text
                    margin={detectMobile() ? '15px 0 0' : '25px 0 0'}
                    size="x1"
                    padding="0"
                    align="left"
                    color="#333333"
                    lh={'22'}
                >
                    Sådan ser det ud, når du har anvendt dit wildcard på en
                    kamp:
                </Text>

                <Big9OmImageWrapper>
                    <BetLineItemWrapper>
                        <Big9OmLeagueIcon src={engIcon} />
                        <Text margin="0" size="x07" padding="0">
                            Premier League - 15:30
                        </Text>
                    </BetLineItemWrapper>
                    <BetLineItemWrapper
                        className={detectMobile() ? 'sm' : 'xl'}
                        margin={'0'}
                    >
                        <Text
                            margin="5px 0 0"
                            size="x15"
                            bold
                            color="#333"
                            padding="0"
                        >
                            1. Manchester United - Liverpool
                        </Text>
                        <img
                            src={ArrowRightImg}
                            className={'arrowRight'}
                            alt=""
                        />
                    </BetLineItemWrapper>
                    <BetLineItemWrapper
                        margin={'15px 0 0'}
                        className={detectMobile() ? 'sm' : 'xl'}
                    >
                        <WildcardActive>
                            <Text
                                size="x1"
                                padding="0"
                                margin={'0'}
                                weight="900"
                                align="left"
                                color="#333333"
                            >
                                Wildcard - alle udfald
                            </Text>
                            <Text
                                size="x1"
                                margin={'0'}
                                padding="0"
                                weight="900"
                                align="right"
                                color="#333333"
                            >
                                Fjern
                            </Text>
                        </WildcardActive>
                    </BetLineItemWrapper>
                </Big9OmImageWrapper>

                <Text
                    margin={detectMobile() ? '15px 0 0' : '25px 0 0'}
                    size="x1"
                    padding="0"
                    align="left"
                    color="#333333"
                    lh={'22'}
                >
                    Sådan ser det ud, når du har lavet en helgardering på en
                    kamp uden at anvende dit wildcard:
                </Text>

                <Big9OmImageWrapper>
                    <BetLineItemWrapper>
                        <Big9OmLeagueIcon src={engIcon} />
                        <Text margin="0" size="x07" padding="0">
                            Premier League - 15:30
                        </Text>
                    </BetLineItemWrapper>
                    <BetLineItemWrapper
                        className={detectMobile() ? 'sm' : 'xl'}
                        margin={'0'}
                    >
                        <Text
                            margin="5px 0 0"
                            size="x15"
                            bold
                            color="#333"
                            padding="0"
                        >
                            1. Manchester United - Liverpool
                        </Text>
                        <img
                            src={ArrowRightImg}
                            className={'arrowRight'}
                            alt=""
                        />
                    </BetLineItemWrapper>
                    <BetLineItemWrapper
                        margin={'15px 0 0'}
                        className={detectMobile() ? 'sm' : 'xl'}
                    >
                        <ButtonsWrapper className="three">
                            <BetDefault className="isDescription active">
                                1
                            </BetDefault>
                            <BetDefault className="isDescription active">
                                X
                            </BetDefault>
                            <BetDefault className="isDescription active">
                                2
                            </BetDefault>
                        </ButtonsWrapper>
                        <ButtonsWrapper margin="0 0 0 5px" className="two">
                            <BetWider className="isDescription active">
                                {detectMobile() ? 'O 2.5' : 'Over 2.5'}
                            </BetWider>
                            <BetWider className="isDescription active">
                                {detectMobile() ? 'U 2.5' : 'Under 2.5'}
                            </BetWider>
                        </ButtonsWrapper>
                        <BetWider className="isDescription" margin="0 0 0 5px">
                            {detectMobile() ? 'W' : 'Wildcard'}
                        </BetWider>
                    </BetLineItemWrapper>
                </Big9OmImageWrapper>

                <Text
                    margin={'40px 0 0 '}
                    size="x25"
                    padding="0"
                    weight="900"
                    align="left"
                    color="#333333"
                >
                    Sådan vinder du i Big 9:
                </Text>
                <Text
                    margin={detectMobile() ? '15px 0 0' : '25px 0 0'}
                    size="x1"
                    padding="0"
                    align="left"
                    color="#333333"
                    lh={'22'}
                >
                    Du skal have ni, otte eller syv rigtige på din kupon for at
                    vinde. Derudover skal gevinsten være på mindst 15 kr. –
                    ellers bliver puljen overført til næste uges Big 9.
                    Fordelingen af præmiepuljen for ni, otte og syv rigtige kan
                    du løbende se i bunden på Big 9-forsiden eller under
                    resultat-menuen.
                </Text>
                <Text
                    margin={detectMobile() ? '15px 0 0' : '25px 0 0'}
                    size="x1"
                    padding="0"
                    align="left"
                    color="#333333"
                    lh={'22'}
                >
                    Hvis der er mange favoritter på kuponen, som vinder, vil ni
                    rigtige give mindre, end hvis der er store overraskelser.
                    Derfor er et godt tip at gå efter overraskelser på kuponen,
                    hvis du går efter millionerne.
                </Text>

                {/*<Text*/}
                {/*    margin={'40px 0 0 '}*/}
                {/*    size="x25"*/}
                {/*    padding="0"*/}
                {/*    weight="900"*/}
                {/*    align="left"*/}
                {/*    color="#333333"*/}
                {/*>*/}
                {/*    Gange-kuponer:*/}
                {/*</Text>*/}
                {/*<Text*/}
                {/*    margin={detectMobile() ? '15px 0 0' : '25px 0 0'}*/}
                {/*    size="x1"*/}
                {/*    padding="0"*/}
                {/*    align="left"*/}
                {/*    color="#333333"*/}
                {/*    lh={'22'}*/}
                {/*>*/}
                {/*    Såfremt du tror på favoritterne og satser på, at de vinder,*/}
                {/*    kan du spille <i>gange-kuponer</i>, hvor du fordobler din*/}
                {/*    rækkepris fra 0,5 kr. til enten 1 kr., 2 kr. 5 kr., 10 kr.*/}
                {/*    eller 20 kr.*/}
                {/*</Text>*/}
                {/*<Text*/}
                {/*    margin={detectMobile() ? '15px 0 0' : '25px 0 0'}*/}
                {/*    size="x1"*/}
                {/*    padding="0"*/}
                {/*    align="left"*/}
                {/*    color="#333333"*/}
                {/*    lh={'22'}*/}
                {/*>*/}
                {/*    <i>Eksempel:</i> Hvis ni rigtige giver 50.000 kr., og din*/}
                {/*    rækkepris er 0,5 kr., har du én vinderrække og vinder 50.000*/}
                {/*    kr. Havde du valgt en rækkepris på 1 kr., ville du vinde*/}
                {/*    100.000 kr., da du så har to vinderrækker.*/}
                {/*</Text>*/}

                {/*<Big9OmSetBetWrapper>*/}
                {/*    <Big9OmSetBetTopLine />*/}
                {/*    <Big9OmSetBetSettings>*/}
                {/*        <Big9OmSetBetSettingsItem>*/}
                {/*            <Text*/}
                {/*                margin={'0'}*/}
                {/*                size="x1"*/}
                {/*                padding="0"*/}
                {/*                align="center"*/}
                {/*                color="#333333"*/}
                {/*                width={'auto'}*/}
                {/*            >*/}
                {/*                Antal rækker*/}
                {/*            </Text>*/}
                {/*            <Text*/}
                {/*                margin={'0'}*/}
                {/*                size="x15"*/}
                {/*                padding="0"*/}
                {/*                align="center"*/}
                {/*                color="#333333"*/}
                {/*                width={'auto'}*/}
                {/*                bold={true}*/}
                {/*            >*/}
                {/*                1.152*/}
                {/*            </Text>*/}
                {/*        </Big9OmSetBetSettingsItem>*/}
                {/*        <Big9OmSetBetSettingsItem className={'active'}>*/}
                {/*            <Text*/}
                {/*                margin={'0'}*/}
                {/*                size="x1"*/}
                {/*                padding="0"*/}
                {/*                align="center"*/}
                {/*                color="#333333"*/}
                {/*                width={'auto'}*/}
                {/*            >*/}
                {/*                Rækkepris*/}
                {/*            </Text>*/}
                {/*            <Text*/}
                {/*                margin={'0'}*/}
                {/*                size="x15"*/}
                {/*                padding="0"*/}
                {/*                align="center"*/}
                {/*                color="#333333"*/}
                {/*                width={'auto'}*/}
                {/*                bold={true}*/}
                {/*            >*/}
                {/*                0,5 kr.*/}
                {/*            </Text>*/}
                {/*        </Big9OmSetBetSettingsItem>*/}
                {/*        <Big9OmSetBetSettingsItem>*/}
                {/*            <Text*/}
                {/*                margin={'0'}*/}
                {/*                size="x1"*/}
                {/*                padding="0"*/}
                {/*                align="center"*/}
                {/*                color="#333333"*/}
                {/*                width={'auto'}*/}
                {/*            >*/}
                {/*                Samlet pris*/}
                {/*            </Text>*/}
                {/*            <Text*/}
                {/*                margin={'0'}*/}
                {/*                size="x15"*/}
                {/*                padding="0"*/}
                {/*                align="center"*/}
                {/*                color="#333333"*/}
                {/*                width={'auto'}*/}
                {/*                bold={true}*/}
                {/*            >*/}
                {/*                576,00 kr.*/}
                {/*            </Text>*/}
                {/*        </Big9OmSetBetSettingsItem>*/}
                {/*        <ArrowTop src={ArrowRightImg} />*/}
                {/*    </Big9OmSetBetSettings>*/}
                {/*    <Big9OmSetBetAmountWrapper>*/}
                {/*        <Big9OmSetBetAmountItem className={'active'}>*/}
                {/*            0.5 kr.*/}
                {/*        </Big9OmSetBetAmountItem>*/}
                {/*        <Big9OmSetBetAmountItem>1 kr.</Big9OmSetBetAmountItem>*/}
                {/*        <Big9OmSetBetAmountItem>2 kr.</Big9OmSetBetAmountItem>*/}
                {/*        <Big9OmSetBetAmountItem>5 kr.</Big9OmSetBetAmountItem>*/}
                {/*        <Big9OmSetBetAmountItem>10 kr.</Big9OmSetBetAmountItem>*/}
                {/*        <Big9OmSetBetAmountItem>20 kr.</Big9OmSetBetAmountItem>*/}
                {/*    </Big9OmSetBetAmountWrapper>*/}
                {/*</Big9OmSetBetWrapper>*/}

                <Text
                    margin={'40px 0 0'}
                    size="x25"
                    padding="0"
                    weight="900"
                    align="left"
                    color="#333333"
                >
                    Sådan udregner du din Big9 kupon:
                </Text>
                <Text
                    margin={detectMobile() ? '15px 0 0' : '25px 0 0'}
                    size="x1"
                    padding="0"
                    align="left"
                    color="#333333"
                    lh={'22'}
                >
                    Rækkeprisen starter ved 0.5 kr., og du betaler for alle de
                    rækker, du laver (bortset fra wildcardet).
                </Text>
                <Text
                    margin={detectMobile() ? '15px 0 0' : '25px 0 0'}
                    size="x1"
                    padding="0"
                    align="left"
                    color="#333333"
                    lh={'22'}
                >
                    Vælger du fx alle udfald i en kamp (1X2 samt over og under
                    2,5 mål), giver det seks rækker (3 x 2) = 6 kr.
                </Text>
                <Text
                    margin={detectMobile() ? '15px 0 0' : '25px 0 0'}
                    size="x1"
                    padding="0"
                    align="left"
                    color="#333333"
                    lh={'22'}
                >
                    Vælger du 1X samt over 2,5 mål i en anden kamp, giver det to
                    rækker (2 x 1) = 2 kr.
                </Text>
                <Text
                    margin={detectMobile() ? '15px 0 0' : '25px 0 0'}
                    size="x1"
                    padding="0"
                    align="left"
                    color="#333333"
                    lh={'22'}
                >
                    Du finder den samlede pris for din kupon ved at gange
                    antallet af rækker (bortset fra wildcardet) for samtlige af
                    kuponens ni kampe.
                </Text>
                <Text
                    margin={detectMobile() ? '15px 0 0' : '25px 0 0'}
                    size="x1"
                    padding="0"
                    align="left"
                    color="#333333"
                    lh={'22'}
                >
                    Læs mere om Big 9 her:{' '}
                    <a
                        href="https://intercom.help/25syv/da/articles/6725594-big-9"
                        target="_blank"
                    >
                        https://intercom.help/25syv/da/articles/6725594-big-9
                    </a>
                </Text>
            </Big9OmContent>
        </Big9OmWrapper>
    );
};

export default Big9Om;
